import React from 'react';

import './styles.css';

import { FaClipboardList, FaUserCheck } from 'react-icons/fa';
import { months } from '../../../../../functions/formatDate';

import { Link } from 'react-router-dom';

// props.listOption == 0    -> Chamada pendente
// props.listOption == 1    -> Chamada registrada
// props.listOption == -1   -> Chamada não liberada

// props.nextCheck == true  -> Tag "Próximo" adicionada

export default function TrainingsCard(props) {
    // const listStatus = (listOption) => {
    //     if (listOption === 0) return "Chamada pendente"
    //     else if (listOption === 1) return "Checkout pendente"
    //     else if (listOption === 2) return "Aula finalizada"
    //     else return "Chamada não liberada"
    // }

    return (
        <li className={'trainings-group-card' + (props.listOption === 2 ? ' check' : '')}>
            <Link to={`/academia/turmas/${props.class.id}`}>
                <h4 className="class-name">Turma {props.class.nome}</h4>
            </Link>
            <p><b>Das {props.start_time} às {props.end_time}</b></p>
            <div className="tags">
                <span>
                    <p>{props.class.faixa_etaria}</p>
                </span>
                <span className={(props.listOption === 1 | props.listOption === 2) ? 'check' : (props.listOption === -1 ? 'none' : '')}>
                    <p>{props.type}</p>
                </span>
                {
                    props.nextCheck ?
                        <span className='next'><p>Próximo</p></span>
                        : []
                }
            </div>
            {
                props.hideCallListOptions !== true ?
                    <div className="trainings-group-card-options">
                        {
                            props.listOption !== -1 ?
                                <button
                                    className={"call-list  " + (props.callList ? 'check' : '')}
                                    onClick={() => {
                                        const dateNow = new Date();
                                        if (props.callList)
                                            props.showPopupCallList(props.callList);
                                        else
                                            props.showPopupNewCallList({
                                                dateTime: `${dateNow.getDate()} de ${months[Number(dateNow.getMonth())]} de ${dateNow.getFullYear()} às ${props.start_time}`,
                                                time: props.start_time,
                                                type: 'Treino',
                                                trainingId: props.id,
                                                classId: props.class.id
                                            });
                                    }}
                                ><FaClipboardList /></button>
                                : []
                        }
                        {
                            props.callList ?
                                <button
                                    className='checkout'
                                    onClick={() => props.showPopupCheckout(props.callList)}
                                ><FaUserCheck /></button>
                                : []
                        }
                    </div>
                    : []
            }
        </li >
    )
}